import api from "./api";

export const getReviews = async () => {
    try {
        const response = await api.get(`/reviews?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getReviewsByEstablishment = async (id) => {
    try {
        const response = await api.get(`/reviews`, {
            params: {
                populate: {
                    'author': {
                        populate: ['profilePicture']
                    }
                },
                filters: {
                    establishment: {
                        documentId: {
                            $eq: id
                        }
                    }
                }
            }
        });
        return response.data.data;
    } catch (e) {
        console.error(e);
    }
};

export const getSingleReview = async (id) => {
    try {
        const response = await api.get(`/reviews/${id}?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const checkReviewed = async (userId, establishmentId) => {
    try {
        const response = await api.get(`/reviews`, {
            params: {
                filters: {
                    $and: [
                        {
                            establishment: {
                                documentId: {
                                    $eq: establishmentId
                                }
                            }
                        },
                        {
                            author: {
                                id: {
                                    $eq: userId
                                }
                            }
                        }
                    ]
                }
            }
        });
        // console.log(response.data.data.length > 0);
        return response.data.data.length > 0; // Returns true if user has already reviewed
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const createReview = async (data) => {
    try {
        const response = await api.post(`/reviews`, {data});
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getReviewsStatsForEstablishment = async (id) => {
    try {
        const reviews = await getReviewsByEstablishment(id);
        
        if (!reviews || reviews.length === 0) {
            return {
                count: 0,
                average: 0
            };
        }

        const count = reviews.length;
        const sum = reviews.reduce((acc, review) => 
            acc + (review.rating || 0), 0);
        const average = (sum / count).toFixed(1);

        return {
            count,
            average: parseFloat(average)
        };
    } catch (e) {
        console.error(e);
        return {
            count: 0,
            average: 0
        };
    }
};